/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `WorkspacePremiumIconProps` interface defines the properties for the WorkspacePremiumIcon component.
 */
interface WorkspacePremiumIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "workspace_premium" — outlined, weight 300.
 * Award badge icon for the Expert category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const WorkspacePremiumIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'WorkspacePremiumIcon',
    width
}: WorkspacePremiumIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m390.39-420.46 34.07-109.23-89.23-67.08h109.46L480-710l34.31 113.23h110.46l-88.85 67.08L569-420.46 480-488l-89.61 67.54ZM262.85-70.77v-282.85q-43.08-43.15-62.96-96.84Q180-504.15 180-560q0-126.77 86.62-213.38Q353.23-860 480-860t213.38 86.62Q780-686.77 780-560q0 55.85-19.89 109.54-19.88 53.69-62.96 96.84v282.85L480-140.16 262.85-70.77Zm397.8-308.58q73.96-73.96 73.96-180.65 0-106.69-73.96-180.65-73.96-73.96-180.65-73.96-106.69 0-180.65 73.96-73.96 73.96-73.96 180.65 0 106.69 73.96 180.65 73.96 73.96 180.65 73.96 106.69 0 180.65-73.96ZM308.23-133.23 480-186.31l171.77 53.08v-182.93q-38.08 29-82.73 42.58Q524.38-260 480-260q-44.38 0-89.04-13.58-44.65-13.58-82.73-42.58v182.93ZM480-225Z" />
    </svg>
);

WorkspacePremiumIcon.displayName = 'WorkspacePremiumIcon';